<div class="bg">
    <nav class="navbar d-flex justify-content-center">
        <div class="row col-lg-10 d-flex justify-content-between align-items-center">
            <div class=" col-lg-5 logoText mr-auto p-2">
                <img  width="200" src="assets/Icones/EEYAA_logo2A.png" alt="" srcset="">
            </div>
            <div  class="col-lg-7 d-flex   justify-content-between ">
                <ul class="menu d-flex align-items-center">
                    <li><a routerLink="/presentation/concepts">Notre concept</a></li>
                    <li><a routerLink="/presentation/services">Nos services</a></li>
                    <li><a routerLink="/presentation/joinUs">Pourquoi nous réjoindre ?</a></li>
                </ul>
                <a (click)="shwowLoginForm()" type="button" class="lognBtn" >Se connecter</a>
             
            </div>
        </div>
    </nav>

    <div  class="registerSerction d-flex align-items-center row ">
        <div  class="col-lg-1">
          <div [ngClass]="{ShowLoginFomr :loginForm == true }"  class="login">
          <app-login-form></app-login-form>
          </div>
        </div>
        <div class="col-lg-5   d-flex  d-flex align-items-center justify-content-center text-center  flex-column ">
            <app-carousel></app-carousel>
            <div class="registerBtn d-flex mt-4  justify-content-center pl-2">
                <a style="cursor: pointer;" routerLink="/registration/entreprise" class="color1 mx-3">Je suis une entreprise</a>
                <a style="cursor: pointer;" routerLink="/registration/talent" class="color1">Je suis un jeune talent</a>
            </div>
        </div>
       <div>
       
       </div>
    </div>

</div>